/**
 * Individual action steps on the results page.
 */
import React, { PropTypes } from 'react';

function ResultsActionStep({ step }) {
  return (
    <div>
      <div>
        {step.stepValue}
      </div>
      <div>
        <strong>Finish By:</strong> {step.timeValue}
      </div>
    </div>
  );
}

ResultsActionStep.propTypes = {
  step: PropTypes.shape({
    stepValue: PropTypes.string,
    timeValue: PropTypes.string,
  }),
};

export default ResultsActionStep;



// WEBPACK FOOTER //
// js/src/goals/ResultsActionStep.js